/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResponseErrorNotAcceptableAllOfError } from './ResponseErrorNotAcceptableAllOfError';
import {
    ResponseErrorNotAcceptableAllOfErrorFromJSON,
    ResponseErrorNotAcceptableAllOfErrorFromJSONTyped,
    ResponseErrorNotAcceptableAllOfErrorToJSON,
} from './ResponseErrorNotAcceptableAllOfError';

/**
 * 
 * @export
 * @interface ResponseErrorNotAcceptableAllOf
 */
export interface ResponseErrorNotAcceptableAllOf {
    /**
     * 
     * @type {ResponseErrorNotAcceptableAllOfError}
     * @memberof ResponseErrorNotAcceptableAllOf
     */
    error: ResponseErrorNotAcceptableAllOfError;
}

/**
 * Check if a given object implements the ResponseErrorNotAcceptableAllOf interface.
 */
export function instanceOfResponseErrorNotAcceptableAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "error" in value;

    return isInstance;
}

export function ResponseErrorNotAcceptableAllOfFromJSON(json: any): ResponseErrorNotAcceptableAllOf {
    return ResponseErrorNotAcceptableAllOfFromJSONTyped(json, false);
}

export function ResponseErrorNotAcceptableAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseErrorNotAcceptableAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'error': ResponseErrorNotAcceptableAllOfErrorFromJSON(json['error']),
    };
}

export function ResponseErrorNotAcceptableAllOfToJSON(value?: ResponseErrorNotAcceptableAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'error': ResponseErrorNotAcceptableAllOfErrorToJSON(value.error),
    };
}

